<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header"
               class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>组织
          </div>
          <div style="overflow:auto;height: calc(100vh - 179px);">
            <es-org-tree @clickByOrg="queryTaskList"
                         @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header"
               class="card-header">
            <i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>任务
          </div>
          <div class="es-op-box">

            <el-date-picker style="float: left;width:300px"
                            format="yyyy-MM-dd"
                            v-model="dateTime"
                            type="daterange"
                            size="small"
                            class="query"
                            range-separator="至"
                            start-placeholder="计划开始日期起始"
                            end-placeholder="计划开始日期结束"
                            clearable
                            @clear="() => { this.dateTime = []; }"
                            @change="() => { this.queryObj.pageNum = 1; loadTaskList() }">
            </el-date-picker>
            <el-select style="float: left;"
                       class="query"
                       size="small"
                       v-model="queryObj.systemId"
                       placeholder="请选择系统专业"
                       clearable
                       filterable
                       @clear="() => {
                delete this.queryObj.systemId
              }"
                       @change="() => { this.queryObj.pageNum = 1; loadTaskList() }">
              <el-option v-for="item in systems"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-select style="float: left;"
                       class="query"
                       size="small"
                       v-model="queryState"
                       placeholder="请选择状态"
                       clearable
                       filterable
                       @clear="() => {
                this.queryState = null
              }"
                       @change="() => { this.queryObj.pageNum = 1; loadTaskList() }">
              <el-option v-for="item in statesArr"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-input placeholder="请输入任务名称"
                      v-model="queryObj.keyWord"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="() => { this.queryObj.pageNum = 1; loadTaskList() }">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <br><br>
          <el-table :data="pageData.list"
                    ref="taskTable"
                    show-overflow-tooltip
                    border
                    stripe
                    size="mini"
                    height="calc(100vh - 250px)"
                    v-loading="loading">
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="taskTypeName"
                             label="任务类型">
            </el-table-column>
            <el-table-column prop="name"
                             label="任务名称">
            </el-table-column>
            <el-table-column prop="orgName"
                             label="组织">
            </el-table-column>
            <el-table-column prop="systemName"
                             label="系统专业">
            </el-table-column>
            <el-table-column prop="chargePersonName"
                             label="责任人">
            </el-table-column>
            <el-table-column prop="planStartTime"
                             label="计划开始时间">
            </el-table-column>
            <el-table-column prop="planEndTime"
                             label="计划结束时间">
            </el-table-column>

            <el-table-column prop="state"
                             label="状态"
                             width="82"
                             align="center">
              <template slot-scope="scope">
                <el-tag size="mini"
                        :type="stateFormat(scope.row, 1)">{{ scope.row.statename }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作"
                             width="60"
                             align="center">
              <template slot-scope="scope">

                <el-link :underline="false"
                         title="详情"
                         @click="view(scope.row)"
                         type="success"><i class="el-icon-font el-icon-view"></i></el-link>

              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
                           @change="
              (cpage) => {
                this.queryObj.pageNum = cpage
                this.loadTaskList()
              }
            ">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!--查看详情-->
    <el-dialog :visible.sync="viewVisible"
               width="800px"
               style="padding-top: 0px;">

      <span slot="title">
        <i class="el-icon-font el-icon-view el-icon--left"></i>任务详情
      </span>
      <el-tabs type="card">
        <el-tab-pane label="基本信息">
          <div v-loading="viewLoading">
            <el-descriptions :column="3"
                             style="cursor: pointer; margin-bottom: 12px"
                             size="mini"
                             border>
              <el-descriptions-item label="所属组织"
                                    :labelStyle='labelStyle'
                                    v-if="taskInfo.orgName!=''&&taskInfo.orgName!=null">{{
                    taskInfo.orgName
                  }}</el-descriptions-item>
              <el-descriptions-item label="所属系统"
                                    :labelStyle='labelStyle'
                                    v-if="taskInfo.systemName!=''&&taskInfo.systemName!=null">{{
                    taskInfo.systemName
                  }}</el-descriptions-item>
              <el-descriptions-item label="任务名称"
                                    :labelStyle='labelStyle'
                                    v-if="taskInfo.name!=''&&taskInfo.name!=null">{{
                    taskInfo.name
                  }}</el-descriptions-item>
              <el-descriptions-item label="当前状态"
                                    :labelStyle='labelStyle'>
                <div style="width: 200px">
                  <el-tag>{{ stateFormat(taskInfo, 2) }}</el-tag>
                </div>

              </el-descriptions-item>
              <el-descriptions-item label="计划开始时间"
                                    :labelStyle='labelStyle'
                                    v-if="taskInfo.planStartTime!=''&&taskInfo.planStartTime!=null">{{
                    taskInfo.planStartTime
                  }}</el-descriptions-item>
              <el-descriptions-item label="计划结束时间"
                                    :labelStyle='labelStyle'
                                    v-if="taskInfo.planEndTime!=''&&taskInfo.planEndTime!=null">{{
                    taskInfo.planEndTime
                  }}</el-descriptions-item>
              <el-descriptions-item label="实际完成时间"
                                    :labelStyle='labelStyle'
                                    v-if="taskInfo.doneTime!=''&&taskInfo.doneTime!=null">{{
                    taskInfo.doneTime
                  }}</el-descriptions-item>
              <el-descriptions-item label="创建时间"
                                    :labelStyle='labelStyle'
                                    v-if="taskInfo.des!=''&&taskInfo.des!=null">{{
                    taskInfo.des
                  }}</el-descriptions-item>
              <el-descriptions-item label="任务描述"
                                    :labelStyle='labelStyle'
                                    v-if="taskInfo.taskDes!=''&&taskInfo.taskDes!=null">{{
                    taskInfo.taskDes
                  }}</el-descriptions-item>
              <el-descriptions-item label="完成情况描述"
                                    :labelStyle='labelStyle'
                                    v-if="taskInfo.doneDes!=''&&taskInfo.doneDes!=null">{{
                    taskInfo.doneDes
                  }}</el-descriptions-item>
              <el-descriptions-item label="责任人"
                                    :labelStyle='labelStyle'
                                    v-if="taskInfo.chargePersonName!=''&&taskInfo.chargePersonName!=null">{{
                    taskInfo.chargePersonName
                  }}</el-descriptions-item>
              <el-descriptions-item label="协作人员"
                                    :labelStyle='labelStyle'
                                    v-if="taskInfo.companionName!=''&&taskInfo.companionName!=null">{{
                    taskInfo.companionName
                  }}</el-descriptions-item>
              <template v-for="info in taskInfo.list" >
                <el-descriptions-item :label="info.label" :key="info.id"
                                    :labelStyle='labelStyle'>
                <el-image
                  v-for="(item, i) in showImgs(info)"
                  :key="i"
                  style="
                    width: 20px;
                    height: 20px;
                    margin-left: 4px;
                    position: relative;
                    top: 5px;
                    border-radius: 4px;
                  "
                  :src="item"
                  :preview-src-list="attachImg[info.id + '_id']"
                >
                </el-image>
                                  </el-descriptions-item>
              </template>    
            </el-descriptions>
            <es-img :info="taskInfo"
                    :fileList="fileListView"
                    type="view"></es-img>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer">
        <el-button size="mini"
                   type="primary"
                   @click="viewVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dateutils from '../../utils/dateutils.js'

export default {
  name: 'task',
  props: ["funcs", "paramId"],
  data () {
    return {
      //label样式
      labelStyle: { 'width': '120px' },
      orgTree: [],//所属组织
      statesArr: [{ id: 1, name: '未开启' }, { id: 2, name: '执行中' }, { id: 3, name: '已完成' }, { id: 4, name: '逾期完成' }, { id: 5, name: '未完成' }],//状态
      queryState: null,
      systems: [],//系统专业
      dateTime: [],//上报起止日期
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      taskInfo: {}, //任务信息
      attachImg: {},
      viewVisible: false,
      loading: false,
      viewLoading: false,
      saving: false,
      url: '',
      fileListView: [],


    }
  },
  methods: {

    //页面初始化
    init () {
      this.loadSystemListAll()
      this.loadTaskList()

      //弹出详情

      if (this.paramId != null) {
        this.viewVisible = false
        this.view({ 'id': this.paramId })
      }
    },

    initOrgTree (orgTree) {
      this.orgTree = orgTree
    },
    showImgs(row) {
      console.log(row);
      if (row.attachImgs == null) {
        return [];
      } else {
        let attachImgs = [];
        JSON.parse(row.attachImgs).forEach((e) => {
          attachImgs.push(
            this.$api +
              e.url +
              "&platform=web&token=" +
              this.$store.getUser().token
          );
        });
        if (attachImgs.length > 0) {
          this.attachImg[row.id + "_id"] = attachImgs;
        }
        console.log(row.attachImgs);
        return attachImgs;
      }
    },
    //初始化系统下拉框
    loadSystemListAll () {
      this.$ajax.get('/base/system/list_all').then((msg) => {
        this.systems = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },

    //从后台查询任务列表
    loadTaskList () {
      this.loading = true

      this.$set(this.queryObj, 'queryTimeStart', null);
      this.$set(this.queryObj, 'queryTimeEnd', null);
      //上报起止日期格式化
      if (this.dateTime != null && this.dateTime.length != 0) {

        this.$set(this.queryObj, 'queryTimeStart', dateutils.dateFormat("YYYY-mm-dd", this.dateTime[0]) + ' 00:00:00')
        this.$set(this.queryObj, 'queryTimeEnd', dateutils.dateFormat("YYYY-mm-dd", this.dateTime[1]) + ' 23:59:59')
      }

      this.formatQuerySate();//整理查询状态，使之适配后台

      this.$set(this.queryObj, 'orderBy', "create_time desc")
      console.log(this.queryObj)
      this.$ajax.get('/buss/task/list', this.queryObj).then((msg) => {
        this.pageData = msg

        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    formatQuerySate () {

      var nowTime = dateutils.dateFormat("YYYY-mm-dd HH:MM", new Date()) //当前时间

      delete this.queryObj.state
      delete this.queryObj.stateAdd

      if (this.queryState == 1) {//未开启

        this.queryObj.state = 0
        this.queryObj.stateAdd = "'" + nowTime + "' < plan_start_time "
      }
      if (this.queryState == 2) {//执行中

        this.queryObj.state = 0
        this.queryObj.stateAdd = "'" + nowTime + "' between plan_start_time and plan_end_time "
      }

      if (this.queryState == 3) {//已完成

        this.queryObj.state = 1
        this.queryObj.stateAdd = " done_time between plan_start_time and plan_end_time "
      }
      if (this.queryState == 4) {//逾期完成

        this.queryObj.state = 1
        this.queryObj.stateAdd = " done_time > plan_end_time "
      }
      if (this.queryState == 5) {//未完成

        this.queryObj.state = 0
        this.queryObj.stateAdd = "'" + nowTime + "' > plan_end_time "
      }

    },

    queryTaskList (orgIds) {
      this.queryObj.pageNum = 1
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.loadTaskList()
    },

    //查看任务详情
    view (row) {
      this.viewVisible = true
      this.viewLoading = true
      this.fileListView = []
      this.$ajax.get('/buss/task/load_detail', { id: row.id }).then((msg) => {
        //初始化图片
        if (msg.attachImgs != null && msg.attachImgs != '') {
          let temp = JSON.parse(msg.attachImgs)
          temp.forEach(e => {
            this.fileListView.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
          })
        }

        this.taskInfo = msg
        this.viewLoading = false
      }).catch(err => {
        this.$message.error(err)
        this.viewVisible = false
        this.viewLoading = false
      })
    },

    //显示状态，type=1列表用，type=2详情用
    stateFormat (row, type) {

      var nowTime = dateutils.dateFormat("YYYY-mm-dd HH:MM:SS", new Date())//当前时间

      if (row.state == 0 && nowTime < row.planStartTime) {
        if (type == 1) {
          row.statename = "未开启"
          return "primary"
        }
        return '未开启'
      } else if (row.state == 0 && nowTime >= row.planStartTime && nowTime <= row.planEndTime) {
        if (type == 1) {
          row.statename = "执行中"
          return "primary"
        }
        return '执行中'
      } else if (row.state == 1 && row.doneTime >= row.planStartTime && row.doneTime <= row.planEndTime) {
        if (type == 1) {
          row.statename = "已完成"
          return "success"
        }
        return '已完成'
      } else if (row.state == 2) {
        if (type == 1) {
          row.statename = "已确认"
          return "success"
        }
        return '已确认'
      } else if (row.state == 1 && row.doneTime > row.planEndTime) {
        if (type == 1) {
          row.statename = "逾期完成"
          return "warning"
        }
        return '逾期完成'
      } else {
        if (type == 1) {
          row.statename = "未完成"
          return "danger"
        }
        return '未完成'
      }
    },

  },
  mounted () {
    this.init()
  },
}
</script>
<style scoped></style>
